const NOTIFI = '[Notifi]';

const types = {
  ENQUEUE_SNACKBAR: `${NOTIFI} ENQUEUE_SNACKBAR`,
  CLOSE_SNACKBAR: `${NOTIFI} CLOSE_SNACKBAR`,
  REMOVE_SNACKBAR: `${NOTIFI} REMOVE_SNACKBAR`
};

export default types;
